module.exports = __webpack_public_path__ + "static/media/MoveInOut-Logo.e41b81c2.svg";